import React, { useState } from "react";
import { events } from "../../Data";
import { useDeviceIsTabletAndMobile } from "../../Utils";

function UpcomingEvent() {
  // Sample data of events

  const [currentIndex, setCurrentIndex] = useState(0);
  // const eventsPerPage = 3;
  const isMobile = useDeviceIsTabletAndMobile();
  const eventsPerPage = isMobile ? 2 : 3;

  // Get the current date
  const currentDate = new Date();

  // Filter events to exclude past events
  const upcomingEvents = events.filter(
    (event) => new Date(event.date) >= currentDate
  );

  // Get the current set of events to display
  const currentEvents = upcomingEvents.slice(
    currentIndex,
    currentIndex + eventsPerPage
  );
  return (
    <div className="laptomSm:mt-8 mt-4 w-full">
      <span className="capitalize font-montserrat font-semibold latopSm:text-2xl text-base text-text-normal">
        Upcoming Events
      </span>

      <div className="w-full grid laptopSm:grid-cols-3 grid-cols-2 gap-2 relative laptopSm:mt-2">
        {/* event list */}
        {currentEvents.length > 0 ? (
          currentEvents.map((event, index) => {
            const eventDate = new Date(event.date);
            const formattedDate = eventDate.toLocaleDateString("en-US", {
              day: "numeric",
            });
            const formattedMonth = eventDate.toLocaleDateString("en-US", {
              month: "short",
            });

            return (
              <div
                key={index}
                className=" w-full md:h-[91px] h-[72px] bg-secondary-normalActive rounded-2xl laptopSm:mt-6 mt-4 flex"
              >
                <div className="w-[43.67%] h-full bg-secondary-darker rounded-bl-2xl rounded-tl-2xl font-montserrat flex flex-col justify-center items-center">
                  <span className="leading-4 font-bold text-base text-white">
                    {formattedMonth}
                  </span>
                  <span className="leading-none font-bold text-lg text-white">
                    {formattedDate}
                  </span>{" "}
                  <span className="leading-none font-medium text-sm text-white">
                    {event.day}
                  </span>
                </div>
                <div className="w-full h-full font-montserrat text-[10px] md:text-xs leading-4 capitalize flex justify-center items-center px-1 text-white break-words">
                  <p> {event.title}</p>
                </div>

                {/* Next and Prev buttons */}

                <button
                  className={`absolute md:right-[-18px] right-[-8px] md:top-[52px] top-9 rounded-full md:w-9 md:h-9 w-8 h-8 bg-white opacity-50 flex items-center justify-center cursor-pointer
                  ${
                    currentIndex + eventsPerPage >= upcomingEvents.length
                      ? "hidden"
                      : "block"
                  }`}
                  onClick={() => {
                    if (currentIndex + eventsPerPage < upcomingEvents.length) {
                      setCurrentIndex(currentIndex + eventsPerPage);
                    }
                  }}
                  disabled={
                    currentIndex + eventsPerPage >= upcomingEvents.length
                  }
                >
                  <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.94625 5.99994L0.346252 1.39994L1.4 0.346191L7.05375 5.99994L1.4 11.6537L0.346252 10.5999L4.94625 5.99994Z"
                      fill="#1C1B1F"
                    />
                  </svg>
                </button>
                {currentIndex > 0 && (
                  <button
                    onClick={() => {
                      if (currentIndex > 0) {
                        setCurrentIndex(currentIndex - eventsPerPage);
                      }
                    }}
                    disabled={currentIndex === 0}
                    className="absolute md:left-[-18px] left-[-8px] md:top-[52px] top-9 rounded-full md:w-9 md:h-9 w-8 h-8 bg-white opacity-50 flex items-center justify-center cursor-pointer disabled:opacity-50"
                  >
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.05375 5.99994L7.65375 10.5999L6.6 11.6537L0.94625 5.99994L6.6 0.346191L7.65375 1.39994L3.05375 5.99994Z"
                        fill="#1C1B1F"
                      />
                    </svg>
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <div className="text-gray-400">No Upcoming Events</div>
        )}

        {/* <div className=" w-full md:h-[91px] h-[72px] bg-secondary-normalActive rounded-2xl md:mt-6 mt-4 flex">
          <div className="w-[43.67%] h-full bg-secondary-darker rounded-bl-2xl rounded-tl-2xl font-montserrat flex flex-col justify-center items-center">
            <span className=" leading-none  font-bold text-lg text-white">
              27
            </span>{" "}
            <span className="leading-none font-medium text-sm text-white">
              SAT
            </span>
          </div>
          <div className="w-full h-full font-montserrat text-sm leading-4 capitalize flex justify-center items-center px-1 text-white">
            <p>Event heading</p>
          </div>
        </div>
        <div className=" w-full md:h-[91px] h-[72px] bg-secondary-normalActive rounded-2xl md:mt-6 mt-4 flex">
          <div className="w-[43.67%] h-full bg-secondary-darker rounded-bl-2xl rounded-tl-2xl font-montserrat flex flex-col justify-center items-center">
            <span className=" leading-none  font-bold text-lg text-white">
              27
            </span>{" "}
            <span className="leading-none font-medium text-sm text-white">
              SAT
            </span>
          </div>
          <div className="w-full h-full font-montserrat text-sm leading-4 capitalize flex justify-center items-center px-1 text-white">
            <p>Event heading</p>
          </div>
        </div>{" "}
        <div className=" w-full md:h-[91px] h-[72px] bg-secondary-normalActive rounded-2xl md:mt-6 mt-4 flex">
          <div className="w-[43.67%] h-full bg-secondary-darker rounded-bl-2xl rounded-tl-2xl font-montserrat flex flex-col justify-center items-center">
            <span className=" leading-none  font-bold text-lg text-white">
              27
            </span>{" "}
            <span className="leading-none font-medium text-sm text-white">
              SAT
            </span>
          </div>
          <div className="w-full h-full font-montserrat text-sm leading-4 capitalize flex justify-center items-center px-1 text-white">
            <p>Event heading</p>
          </div>
        </div>
         */}
      </div>
    </div>
  );
}

export default UpcomingEvent;
